import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/timetables/$type')({
    beforeLoad: requireRouteAudience(['staff']),
    staticData: {
        crumb: {
            label: (match) => formatTimetableType(match.params.type),
        },
    },
})

function formatTimetableType(type: string) {
    switch (type) {
        case 'staff':
            return 'Staff'
        case 'student':
            return 'Student'
        case 'class':
            return 'Class'
        case 'room':
            return 'Room'
        default:
            return type
    }
}
